import React, { Component } from 'react';
import PropTypes from 'prop-types'
import getLocaleMessages from '../../utils/localesMessages';
import * as modalUtils from '../../utils/modalUtils';

const {
  actionable: {
    header,
    msg1,
    msg2,
    review,
    cancel
  },
  close
} = getLocaleMessages('buttons/errors')

export class ActionableErrorModal extends Component {
	static propTypes = {
		buttonFactory: PropTypes.object,
		closeModal: PropTypes.func,
		startOver: PropTypes.func
	}

	render() {
		return (
			<div
				className={`vx_modal-glimpse vx_modalPrepToOpen error_modal actionable ${this.props.buttonFactory.showActionableErrorModal ? 'vx_modalIsOpen' : ''}`}
				id="actionable-error-model"
				role="dialog"
				aria-describedby="actionable-error-model"
				tabIndex="0"
				aria-label="Modal Dialog"
			>
				<div className="vx_modal-content">
					<button
						className="vx_modal-dismiss_x-trigger"
						data-modal-id="_demoVxModal-glimpse"
						onClick={modalUtils.hideActionableErroModal}
					>
            <span className="vx_a11yText">{close}</span>
					</button>

					<div className="attention">
						<span className="vx_icon vx_icon-attention-large" aria-hidden="true"></span>
					</div>

					<header className="vx_modal-header" id="actionable-error-model-header">
						<p>{header}</p>
					</header>

					<div className="vx_modal-body">
						<p id="actionable-error-msg">{msg1}</p>
						<br/>
						<p>{msg2}</p>

						<button
							className="vx_btn vx_btn-primary"
							type="submit"
							onClick={modalUtils.hideActionableErroModal}
						>
							{review}
						</button>
						<button
							className="vx_btn vx_btn-secondary"
							type="submit"
							onClick={this.props.startOver}
						>
							{cancel}
						</button>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./buttons/components/modals/ActionableErrorModal.js